import { Component, ChangeDetectionStrategy, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { tap } from 'rxjs/operators';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { SelectOptionMobile } from '@shared/models/catalog.service';
import { ConnectedPosition } from "@angular/cdk/overlay";
import { CatalogItemsDataService } from '../catalog-items/catalog-items-data.service';


@Component({
  selector: 'app-column-filter',
  templateUrl: './column-filter.component.html',
  styleUrls: ['./column-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnFilterComponent {
  public isMobile = false;
  public isTablet = false;
  public isAllSelected$ = this.catalogItemsDataService.isAllSelected;
  private _selectColumns: SelectOptionMobile[];
  private _dialogRef: MatDialogRef<TemplateRef<any>>;
  public icons = CustomIcons;
  public filterColumnsContainerHeight = 400;
  public filterSelectColumns: SelectOptionMobile[] = [];
  public get selectColumns(): SelectOptionMobile[] {
    return this._selectColumns;
  }
  @Input() public set selectColumns(value: SelectOptionMobile[]) {
    this.catalogItemsDataService.isAllSelected.next(value.every(column => column.isSelected));
    this._selectColumns = value;
    this.filterSelectColumns = value;
  }
  @Input() public isPinned = false;
  @ViewChild('filterTemp') public filterTemp: TemplateRef<any>;
  public overlayPosition: ConnectedPosition[] = [];
  @Output() public readonly changeColumnPinned = new EventEmitter<boolean>();
  @Output() public readonly changeColumn = new EventEmitter<SelectOptionMobile[]>();
  public breakPointObserve$ = this.breakpointObserver
    .observe(['(max-width: 1400px)', '(max-width: 896px) and (orientation: landscape)', '(max-width: 800px)', '(max-width: 420px)'])
    .pipe(
      tap(state => {
        this.isMobile = state.breakpoints['(max-width: 420px)'];
        this.isTablet = state.breakpoints['(max-width: 800px)'];
        this.filterColumnsContainerHeight = state.matches ? 300 : 400;
        if (state.breakpoints['(max-width: 896px) and (orientation: landscape)']) {
          this.filterColumnsContainerHeight = 130;
        }
        this.overlayPosition = [
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'top',
            offsetX: 10,
            offsetY: 10
          }
        ];
      })
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    private catalogItemsDataService: CatalogItemsDataService,
  ) {}

  public onChoose(selectedColumns: boolean[]): void {
    selectedColumns.forEach((isShow, index) => {
      if (this.selectColumns && this.selectColumns[index]) {
        this.selectColumns[index].isSelected = isShow;
      }
    });

    this.changeColumn.emit(this.selectColumns);
  }

  public openModal(): void {
    const config: MatDialogConfig = this.isMobile
      ? {
          maxWidth: '100%',
          width: '100%',
          height: '80%', // `calc(100% - ${window.innerHeight - (this.selectColumns.length * 44 + 80)}px)`,
          position: {
            bottom: '0px'
          },
          panelClass: 'mobile-bottom-show-up-small-dialog',
          backdropClass: 'backdrop',
          hasBackdrop: true
        }
      : {
          width: '360px',
          height: '70%',
          position: {
            bottom: '20px'
          }
        };

    this._dialogRef = this.dialog.open(this.filterTemp, config);
  }

  public closeModal(): void {
    if (this._dialogRef) {
      this._dialogRef.close();
    }
  }

  public toggleColumn(column: SelectOptionMobile) {
    column.isSelected = !column.isSelected;
    this.catalogItemsDataService.isAllSelected.next(this._selectColumns.every(column => column.isSelected));
    this.changeColumn.emit(this.selectColumns);
  }

  public toggleAll(checked: boolean) {
    this._selectColumns.forEach(column => {
      column.isSelected = checked;
    });
    const isAllSelected = this.catalogItemsDataService.isAllSelected.value || false;
    this.catalogItemsDataService.isAllSelected.next(!isAllSelected);
    this.changeColumn.emit(this.selectColumns);
  }

  public pinColumn(pinned: boolean) {
    this.changeColumnPinned.emit(pinned);
  }

  public searchStart($event: string): void {
    this.filterSelectColumns = this._selectColumns.filter(x => x.title.toLowerCase().includes($event.toLowerCase()));
  }
}
